import { useForm } from "@/src/provider/Form/FormProvider";
import Grid from "@mui/material/Grid";
import { emailDefault, isPhoneNumberDefault, minStringLength, requiredValidator } from "@/src/services/validationRules";
import EmailCheck from "@/src/components/EmailCheck/EmailCheck";
import ButtonLoading from "@/src/components/Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "./ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import React from "react";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import { MenuItem, Stack, Typography } from "@mui/material";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { InfoOutlined } from "@mui/icons-material";

type CheckinFormPersonProps = {
  isLoading: boolean;
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  additionalFormFields?: React.ReactNode;
  submitHintText?: string;
};

export default function CheckInFormPerson({ isLoading, emailErrorText, setEmailErrorText, additionalFormFields, submitHintText }: CheckinFormPersonProps) {
  const { handleSubmit } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        sx={{
          alignItems: "baseline",
          justifyContent: "center",
        }}
      >
        <Grid
          sx={{ paddingRight: { md: "3rem" } }}
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <ValidatorSelectField displayEmpty label="Anrede" name={`gender`} autoComplete="sex">
            <MenuItem value={""}>Keine Anrede</MenuItem>
            <MenuItem value={"female"}>Frau</MenuItem>
            <MenuItem value={"male"}>Herr</MenuItem>
          </ValidatorSelectField>
        </Grid>
        <Grid
          sx={{ paddingRight: { sm: "3rem" } }}
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <ValidatorTextField
            name={`givenName`}
            label="Vorname"
            autoComplete="given-name"
            validators={[
              requiredValidator("Bitte geben Sie den Vornamen an"),
              { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
            ]}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <ValidatorTextField
            name={`familyName`}
            label="Nachname"
            autoComplete="family-name"
            validators={[
              requiredValidator("Bitte geben Sie den Nachnamen an"),
              { validator: minStringLength, params: [2], message: "Bitte kontrollieren Sie Ihre Eingabe" },
            ]}
          />
        </Grid>

        {additionalFormFields && (
          <Grid
            size={{
              xs: 12,
              md: 12,
            }}
          >
            {additionalFormFields}
          </Grid>
        )}

        <Grid
          sx={{ paddingRight: { sm: "3rem" } }}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <EmailCheck
            name="email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
            redirectProps={null}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <ValidatorTextField
            name="telephone"
            label="Ihre Telefonnummer"
            autoComplete="tel"
            validators={[requiredValidator("Bitte geben Sie Ihre Telefonnummer an"), ...isPhoneNumberDefault]}
          />
        </Grid>
        <Grid
          sx={{ paddingTop: "1rem" }}
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          {submitHintText && (
            <Stack direction={"row"} sx={{ alignItems: "center" }}>
              <InfoOutlined color={"primary"} />
              <Typography sx={{ color: "primary.main", textAlign: "center" }}>{submitHintText}</Typography>
            </Stack>
          )}
          <ButtonLoading variant="contained" color="primary" sx={{ marginTop: { md: "25px" } }} type="submit" fullWidth isLoading={isLoading}>
            Jetzt kostenlos starten
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
